// extracted by mini-css-extract-plugin
export default {"deleteOverlay":"x4-z","cancel":"y4-z","disabled":"z4-z","delete":"A4-z"};